import React, {useState,useEffect} from 'react';
import {SubmitForm} from '@gull'
import { useTranslate } from 'react-redux-multilingual'
import { useForm } from "react-hook-form";
import axios from 'axios'
import swal from "sweetalert2";
import { Form } from "react-bootstrap";

const CreateSupplementList = (props) => {
    const t = useTranslate();
    const { register, formState: { errors }, handleSubmit, reset, setValue } = useForm();
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [success,setSuccess] = useState(false)

    const [multipleChoice,setMulitpleChoice]=useState(false)
    const [requiredChoice,setRequiredChoice]=useState(false)
    const [order,setOrder]=useState(null)

    // Pour édition
    const [supplementList,setSupplementList]=useState(false)

    useEffect(function () { 
        (async function() {
            if (props.modalEditId!=false) {
                setValidButton(true)
                const response  = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/one/"+props.modalEditId,
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }
                    else{
                        setSupplementList(response.data.data)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
                setValidButton(false)
            }
        })()
    }, [props.modalEditId])

    useEffect(function () {
        if (supplementList!=false) {
            setValue('name',supplementList.name)
            setMulitpleChoice(supplementList.multiple_choice);
            setValue('multiple_choice',supplementList.multiple_choice);
            setRequiredChoice(supplementList.required_choice);
            setValue('required_choice',supplementList.required_choice);
            setOrder(supplementList.order)
            setValue('order',supplementList.order);
        }
    }, [supplementList])

    const onSubmit = async (data) => {
        setValidButton(true)
        setSuccess(false)
        setApiError(false)

        let obj = {
            name: data.name,
            multiple_choice:data.multiple_choice,
            required_choice:data.required_choice,
            order:data.order
        }

        let axioAction = (props.modalEditId) ? axios.put : axios.post
        let url = (props.modalEditId) ? "api/erp/supplement_list/"+props.modalEditId : "api/erp/supplement_list"

        const response  = await axioAction(process.env.REACT_APP_API_URL+url,obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
            }
            else{
                setSuccess(true)
                if(!props.modalEditId){
                    //Dans le cas d'une création on ajoute un nouvelle ligne
                    props.setAllSupplementList([response.data.data,...props.allSupplementList])
                    props.setReloadData(Date.now())
                }else{
                    //Dans le cas d'une édition, on met à jour le nom de la liste d'articles
                    // ici on récupère liste d'article qui doit être mis à jour
                    let list = props.allSupplementList.find(value=>value.id==props.modalEditId)
                    //on met à jour le nom
                    list.name = response.data.data.name
                    list.multiple_choice = response.data.data.multiple_choice
                    list.required_choice = response.data.data.required_choice
                    list.order = response.data.data.order

                    //on met à jour les blocs affiché 
                    let supplementList = props.allSupplementList.map(value=>value.id)
                    let indexToEdit = supplementList.indexOf(props.modalEditId)
                    let newData = props.allSupplementList.filter(value=>value.id!=props.modalEditId)

                    newData.splice(indexToEdit,0, list)

                    props.setAllSupplementList(newData)
                    props.setModalEditId(false)
                }
                
                props.setShow(false)
                reset()
            }
            
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidButton(false)
        setTimeout(()=>{
            setSuccess(false);
        },1000)    
    }

    const handleChange = (e,name) => {
        if (name=='multiple_choice') {
            setMulitpleChoice(!multipleChoice);
            setValue('multiple_choice',!multipleChoice);
        }
        else if (name=='required_choice') {
            setRequiredChoice(!requiredChoice);
            setValue('required_choice',!requiredChoice);
        }
        else {
            setOrder(e.target.value.replace(/[^0-9]/g, ''));
            setValue('order',e.target.value.replace(/[^0-9]/g, ''));
        }
    }

    return(
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group row">
                    <label>{t('listName')+' :'}</label>
                    <div className='col'>
                        <input disabled={validButton} className="form-control" type="text" {...register('name', {required: true})}/>
                        {errors.name?.type === 'required' && (
                        <div className="text-danger mt-1 ml-2">
                            {t('fieldRequired')}
                        </div>)}
                    </div>
                </div>
                <div className="form-group row">
                    <label>{t('multiple_choice')}</label>
                    <div className='col'>
                        <Form.Check
                            {...register("multiple_choice")}
                            type="switch"
                            id="custom-switch"
                            disabled={validButton}
                            checked={multipleChoice}
                            onChange={(e) => handleChange(e,'multiple_choice')}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label>{t('required_choice')}</label>
                    <div className='col'>
                        <Form.Check
                            {...register("required_choice")}
                            type="switch"
                            id="custom-switch"
                            disabled={validButton}
                            checked={requiredChoice}
                            onChange={(e) => handleChange(e,'required_choice')}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label>{t('priority')}</label>
                    <div className='col'>
                        <input {...register("order")} className="form-control" type="number" disabled={validButton} onChange={(e) => handleChange(e,'order')} 
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", ".",","].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                </div>
                <SubmitForm validButton={validButton} success={success} error={apiError} />
            </form>
        </div>
    )
}

export default CreateSupplementList;